module.exports = __webpack_public_path__ + "img/about-us-bg.a9448d30.jpg";